import * as React from "react";

import { t } from "@impero-com/common/utils/i18n";
import { ActionMenu, ActionSpec, Tabs, TabSpec } from "@impero-com/ui";
import { useNavigate } from "react-router-dom";

import { WebRoute } from "routes";

import { OrgApplicationBar } from "../../components/applicationBar/orgApplicationBar";
import { useNewMenu } from "../navigation/useNewMenu";
import { SettingsLayout } from "../settings/SettingsLayout";

const ACTIONS_ID = "taglist-actions";

interface TagsListApplicationBarProps {
    currentTabId: "tab-tags" | "tab-control-program-tags";
    actions?: ActionSpec[];
    children: React.ReactNode;
}

export function TagsListApplicationBar({
    currentTabId,
    actions,
    children,
}: TagsListApplicationBarProps) {
    const navigate = useNavigate();
    const newMenu = useNewMenu();
    const tabSpecs: TabSpec[] = [
        {
            id: "tab-tags",
            label: t("TagManagement_MenuTitle"),
            onClick: () => navigate(WebRoute.TAGS),
        },
        {
            id: "tab-control-program-tags",
            label: t("ControlProgramTagManagement_MenuTitle"),
            onClick: () => navigate(WebRoute.TAGS_CONTROL_PROGRAM),
        },
    ];

    if (newMenu) {
        return (
            <SettingsLayout
                section="tags"
                navigation={
                    <Tabs currentTabId={currentTabId} tabSpecs={tabSpecs} />
                }
                actions={
                    actions && <ActionMenu id={ACTIONS_ID} actions={actions} />
                }
            >
                {children}
            </SettingsLayout>
        );
    }

    return (
        <OrgApplicationBar
            title={t("TagManagement_Title")}
            navigation={{ type: "Tabs", currentTabId, tabSpecs }}
            actions={actions && { id: ACTIONS_ID, actions }}
        >
            {children}
        </OrgApplicationBar>
    );
}
